const createTaskAction = (action) => {
  return `TODO_TASK@${action}`;
};

export const TodoTaskAction = {
  setTodoList: createTaskAction('SET_TODO_TASK_LIST'),
  setFilterParam: createTaskAction('SET_FILTER_PARAM'),
};
